import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { TextArea } from 'semantic-ui-react'

const TextAreaInput = (props) => {
  // const { label, placeHolder, input, meta: { touched, error } } = props
  // const activeClass = classnames({ error: (touched && error) })
  // return (
  //   <FormControl fullWidth>
  //     <InputLabel className={activeClass}>{label}</InputLabel>
  //     <Input
  //       {...input}
  //       multiline
  //       className={activeClass}
  //       placeholder={placeHolder}
  //     />
  //     <FormHelperText className={activeClass}>
  //       {touched ? error : ''}
  //     </FormHelperText>
  //   </FormControl>
  // )
  const { 
    label, placeHolder, input, require, editable, style, specialOnChange, meta: { touched, error },
    resizeVerticalOnly=false,resizeHorizontalOnly=false,rows=3
  } = props
  const activeClass = classnames({error: (touched && error)})
  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ${editable!==false?'editableTextAreaInput':''}`}>
        <TextArea
          {...input}
          rows={rows}
          disabled={editable === false}
          className={activeClass}
          placeholder={placeHolder}
          style={{resize: resizeVerticalOnly?'vertical':resizeHorizontalOnly?'horizontal':'both'}}
          onChange={(e, data) => {
            input.onChange(data.value)
            if (specialOnChange) {
              specialOnChange(data.value)
            }
          }}
        />
      </div>
    </div>
  )
}

export default compose()(TextAreaInput)